import { useContext, useEffect, useState } from "react";
import { database } from "../services/Firebase";
import { DataSnapshot, get, off, onValue, ref } from "firebase/database";
import { AuthContext } from "../App";

type FireBaseQuestions = Record<string, {
    author: {
        name: string;
        avatar: string;
    };
    content: string;
    isAnsweared: boolean;
    isHighlighted: boolean;
    likes: Record<string, {
        authorId: string,
    }>
}>

type Question = {
    id: string,
    author: {
        name: string;
        avatar: string;
    };
    content: string;
    isAnsweared: boolean;
    isHighlighted: boolean;
    likeCount: number;
    hasLiked: string | undefined;
}

export function useRoom(roomId: string) {
    const [title, setTitle] = useState("");
    const [questions, setQuestions] = useState<Question[]>([]);
    const [numberOfQuestions, setNumberOfQuestions] = useState(0);
    const { user } = useContext(AuthContext);

    useEffect(() => {
        onValue(ref(database, `/rooms/${roomId}/questions`), (snapshot: DataSnapshot) => {
            const fireBaseQuestions: FireBaseQuestions = snapshot.val() || {};
            // setQuestions(fireBaseQuestions);
            setNumberOfQuestions(snapshot.size);
            get(ref(database, `/rooms/${roomId}/title`)).then( value => {
                setTitle(value.val());
            })
            
            const parsedQuestion = Object.entries(fireBaseQuestions).map(([key, value]) => {
                return {
                    id: key,
                    content: value.content,
                    author: value.author,
                    isHighlighted: value.isHighlighted,
                    isAnsweared: value.isAnsweared,
                    likeCount: Object.values(value.likes ?? {}).length,
                    hasLiked: Object.entries(value.likes ?? {}).find(([key, value]) => value.authorId === user?.id)?.[0]
                }
            })
            
            // console.log(parsedQuestion)
            setQuestions(parsedQuestion);
        })

        return () => {
            off(ref(database, `/rooms/${roomId}/questions`));
        }

    }, [roomId, user?.id]);

    return { questions, title, numberOfQuestions};
}